export default "__VITE_ASSET__DcPoioKm__"